import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GetChatSetting,
  createInstance,
  getMessages,
  sendMsg,
  sendVerifyotp,
} from "../Axios/user.axios";
import {
  EncryptData,
  NumberChange,
  NumberOnly,
  isEmpty,
} from "../helper/common";
import config from "../helper/config";
import { toast } from "react-toastify";
import { SocketId, socket } from "../socket";
import { IoSend } from "react-icons/io5";
import { Link, useNavigate } from "react-router-dom";
import { DecryptData } from "../helper/common";
import edafacelogo from "../Assets/edaface-logo1.png";
import { IoClose } from "react-icons/io5";
import { IoMdAttach } from "react-icons/io";
import { IoMdDocument } from "react-icons/io";
import OTPInput from "react-otp-input";
import { IoCloseCircleOutline } from "react-icons/io5";
import { MdAccessTime } from "react-icons/md";
import { MdOutlinePlayCircle } from "react-icons/md";

let days = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

let defaulttext =
  "<p>Once Chat is Available You can start chat now please refer our docs.</p>";

export default function Chat() {
  const count = 30;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { payload } = useSelector((state) => state?.LoginReducer?.User);
  const usedata = useSelector((state) => state?.LoginReducer?.User);
  const fileref = useRef();
  const { data, connected, otp } = useSelector(
    (state) => state?.LoginReducer?.Socket
  );
  const [msg, setMsg] = useState("");
  const [EmailId, setEmailId] = useState(payload?.EmailId ?? "");
  const [chattextboxes, setChattextboxes] = useState([]);
  const [chatside, setChatside] = useState(false);
  const [userlogin, setUserlogin] = useState(false);
  const [verifysteps, setVerifysteps] = useState(false);
  const [files, setFiles] = useState([]);
  const [userotp, setUserotp] = useState("");
  const [otpPage, setOrppage] = useState(false);
  const [counter, setCounter] = useState(count);
  const [page, SetPage] = useState("");
  const [Timer, SetTimer] = useState({
    Minutes: 0,
    Seconds: 0,
  });
  const [ChatSettingData, SetChatSettingData] = useState({});
  const [ChatAvailabiltity, SetChatAvailability] = useState({
    status: false,
    text: defaulttext,
  });
  const [DisableStatus, SetDisableStatus] = useState(false);

  useEffect(() => {
    if (otpPage) {
      if (counter == 0) {
        dispatch({
          type: "Socket",
          Socket: {
            Socket: {
              otp: "",
            },
          },
        });
        SetPage("resend");
      }
      const timer =
        counter > 0 && setInterval(() => setCounter(counter - 1), 1000);
      const seconds = String(counter % 60).padStart(2, 0);
      const minutes = String(Math.floor(counter / 60)).padStart(2, 0);
      SetTimer({
        Minutes: minutes,
        Seconds: seconds,
      });
      return () => clearInterval(timer);
    }
  }, [counter, otpPage]);

  useEffect(() => {
    socket.on("userget", async (data) => {
      let Msg = await DecryptData(data);
      setChattextboxes([...chattextboxes, Msg]);
    });
  }, [socket, chattextboxes]);

  useEffect(() => {
    if (!isEmpty(payload)) {
      setEmailId(payload?.EmailId);
    } else {
      setEmailId("");
    }
  }, [payload]);

  useEffect(() => {
    getmsg();
  }, [payload]);
  const getmsg = async () => {
    let resp = await getMessages({ instanceId: data?._id });
    if (resp?.success == "success") {
      setChattextboxes(resp?.data);
    }
  };

  function chatfirst() {
    if (chatside === true) {
      setChatside(false);
    } else if (chatside === false) {
      if (!isEmpty(payload?.EmailId) && !connected) {
        goToChat();
      }
      setChatside(true);
    }
  }
  const goToChat = async () => {
    if (isEmpty(EmailId)) return toast.error("Please fill the Emailid");
    if (!config.EMAIL.test(EmailId))
      return toast.error("Please fill the Correct Email format");
    if (isEmpty(userotp) && isEmpty(EmailId))
      return toast.error("Please fill the OTP");
    if (String(otp) !== String(userotp) || isEmpty(EmailId))
      return toast.error("Incorrect OTP Please check");
    let resp = await createInstance({
      EmailId,
      SocketId,
    });
    if (resp?.success === "success") {
      dispatch({
        type: "Socket",
        Socket: {
          Socket: {
            connected: true,
            data: resp?.data,
          },
        },
      });
      setOrppage(false);
    }
  };

  const messageSend = async () => {
    SetDisableStatus(true);
    if (isEmpty(msg) && files.length == 0) {
      SetDisableStatus(false);
      return toast.error("Please enter Some Message or File");
    }
    let sendData = {
      id: data?._id,
      msg,
      messager: "user",
      files: files,
    };
    let resp = await sendMsg(sendData);
    if (resp?.success === "success") {
      setChattextboxes([...chattextboxes, resp?.data]);
      setMsg("");
      setFiles([]);
    }
    SetDisableStatus(false);
  };

  const handleClick = () => {
    fileref.current.click();
  };

  const getfiles = async (e) => {
    let file = e.target.files;
    let err = "";
    const ext = ["image", "video", "pdf"];
    await Promise.all(
      Object.values(file).map((data) => {
        if (!ext.some((test) => data?.type.includes(test))) {
          err = "please upload image or video or pdf files only";
        }
      })
    );
    if (!isEmpty(err)) return toast.error(err);
    setFiles([...files, ...Object.values(file)]);
  };

  const removeImg = (index) => {
    let allfile = files;
    allfile.splice(index, 1);
    setFiles([...allfile]);
  };

  const msgSend = async () => {
    if (isEmpty(msg)) return toast.error("Please enter Some Message");
    let sendData = {
      id: data?._id,
      msg,
      messager: "user",
    };
    socket.emit("userchat", files, EncryptData(sendData));
    setChattextboxes([...chattextboxes, sendData]);
    setMsg("");
  };

  const chatContainerRef = useRef(null);
  useEffect(() => {
    // Scroll to the bottom of the chat container when messages change
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop =
        chatContainerRef.current.scrollHeight;
    }
  }, [chattextboxes]);

  const sendOtp = async () => {
    let resp = await sendVerifyotp({ EmailId });
    if (resp?.success == "success") {
      dispatch({
        type: "Socket",
        Socket: {
          Socket: {
            otp: resp?.otp,
          },
        },
      });
      setOrppage(true);
      setCounter(count);
      SetPage("");
      toast.success(resp?.msg);
    } else {
      toast.error(resp?.msg);
    }
  };

  useEffect(() => {
    GetChatSettingData();
  }, []);

  const GetChatSettingData = async () => {
    let resp = await GetChatSetting();
    SetChatSettingData(resp?.data ? resp?.data : {});
    console.log("GetChatSetting_resp", resp?.data);
    if (resp?.data) {
      let insttimings = resp?.data?.Timings;
      let setdata = {
        status: false,
        text: defaulttext,
      };
      let d = new Date();
      let getday = d.getDay();
      let dayName = days[getday];
      if (insttimings?.[dayName]?.Status) {
        if (insttimings?.[dayName]?.timing?.length > 0) {
          insttimings[dayName].timing.map((val) => {
            let starttime = new Date().setHours(
              NumberChange(val?.StartHour),
              NumberChange(NumberChange(val?.StartMinute), 0, 0)
            );
            let endtime = new Date().setHours(
              NumberChange(val?.EndHour),
              NumberChange(NumberChange(val?.EndMinute), 0, 0)
            );
            if (
              new Date().getTime() >= starttime &&
              new Date().getTime() <= endtime
            ) {
              setdata.status = true;
            }
          });
          if (!setdata.status) {
            d = new Date(
              new Date(d.getTime()).setDate(new Date(d.getTime()).getDate() + 1)
            );
            getday = d.getDay();
            dayName = days[getday];
          }
        }
      } else {
        d = new Date(
          new Date(d.getTime()).setDate(new Date(d.getTime()).getDate() + 1)
        );
        getday = d.getDay();
        dayName = days[getday];
      }
      if (!setdata?.status) {
        // let timingarr = [];
        // days.map((val) => {
        //     timingarr.push({
        //         DayName: val,
        //     })
        // });
        // let map = {
        //     Sunday: 1,
        //     Monday: 2,
        //     Tuesday: 3,
        //     Wednesday: 4,
        //     Thursday: 5,
        //     Friday: 6,
        //     Saturday: 7,
        // };
        // let mapkeys = Object.keys(map);
        // let curdayindex = mapkeys.indexOf(dayName);
        // map[dayName] = 1;
        // let i = curdayindex >= 6 ? 0 : curdayindex + 1;
        // let currordernumber = 1;

        // while (i != curdayindex && i <= 8) {
        //     if (i >= 6) {
        //         map[mapkeys[i]] = ++currordernumber;
        //         i = 0;
        //     } else {
        //         map[mapkeys[i]] = ++currordernumber;
        //         i = i + 1;
        //     }
        // }

        // timingarr.sort((a, b) => {
        //     return map[a.DayName] - map[b.DayName];
        // });
        // let endmap = false;
        // timingarr.map((val)=>{
        //     console.log('mapppppcheckkkk',val?.DayName,insttimings?.[val?.DayName],insttimings?.[val?.DayName]?.Status,insttimings?.[val?.DayName]?.timing,!endmap,(insttimings?.[val?.DayName]?.Status && insttimings?.[val?.DayName]?.timing?.length > 0 && !endmap ))
        //     if(insttimings?.[val?.DayName]?.Status && insttimings?.[val?.DayName]?.timing?.length > 0 && !endmap ){
        //         setdata.text = resp?.data?.defaulttext ? resp?.data?.defaulttext : defaulttext
        //         endmap = true
        //     }
        // })

        setdata.text = resp?.data?.defaulttext
          ? resp?.data?.defaulttext
          : defaulttext;
      }
      SetChatAvailability(setdata);
    } else {
      SetChatAvailability({
        status: false,
        text: defaulttext,
      });
    }
  };

  return (
    <>
      {/* chart code */}
      <div
        className="chatbox cursor"
        onClick={() => {
          chatfirst();
        }}
      >
        {chatside ? (
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 800 800"
              height="25px"
              width="25px"
              role="img"
              alt="Close icon"
              class="tawk-min-chat-icon"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M466.24042,400.4053l272.927-275.99463c6.94586-8.76452,11.13092-20.00501,11.13092-32.20959 s-4.18506-23.42317-11.21857-32.29724l0.08765,0.10955c-8.76453-6.94588-20.005-11.13094-32.20959-11.13094 c-12.20453,0-23.42316,4.18505-32.29724,11.21858l0.10956-0.08765L401.84311,336.008L125.84851,60.0134 c-8.76452-6.94588-20.00501-11.13094-32.2096-11.13094s-23.42316,4.18506-32.29724,11.21858l0.10955-0.08765 C54.50535,68.77792,50.32029,80.01842,50.32029,92.223s4.18505,23.42317,11.21858,32.29724l-0.08764-0.10956l275.9946,275.99463 L61.45122,673.33234c-6.94588,8.76453-11.13094,20.005-11.13094,32.20959s4.18506,23.42316,11.21858,32.29724l-0.08765-0.1095 c8.19483,7.64703,19.2162,12.33606,31.33314,12.33606c0.83263,0,1.68717-0.02191,2.49789-0.06573h-0.10957 c0.54779,0.02191,1.20512,0.04382,1.86246,0.04382c11.32813,0,21.5388-4.71094,28.79144-12.29224l0.0219-0.02191 l275.99463-272.92703l272.92703,272.92703c7.2746,7.58136,17.48523,12.31415,28.81335,12.31415 c0.65735,0,1.29279-0.02191,1.95013-0.04382h-0.08765c0.72308,0.04382,1.55573,0.06573,2.38831,0.06573 c12.11694,0,23.16022-4.68903,31.37695-12.35797l-0.02185,0.02191c6.94586-8.76447,11.13092-20.005,11.13092-32.20959 c0-12.20453-4.18506-23.42316-11.21857-32.29724l0.08765,0.10956L466.24042,400.4053z"
              ></path>
            </svg>
          </span>
        ) : (
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 800 800"
              height="32px"
              width="32px"
              role="img"
              alt="Chat icon"
              class="tawk-min-chat-icon"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M400 26.2c-193.3 0-350 156.7-350 350 0 136.2 77.9 254.3 191.5 312.1 15.4 8.1 31.4 15.1 48.1 20.8l-16.5 63.5c-2 7.8 5.4 14.7 13 12.1l229.8-77.6c14.6-5.3 28.8-11.6 42.4-18.7C672 630.6 750 512.5 750 376.2c0-193.3-156.7-350-350-350zm211.1 510.7c-10.8 26.5-41.9 77.2-121.5 77.2-79.9 0-110.9-51-121.6-77.4-2.8-6.8 5-13.4 13.8-11.8 76.2 13.7 147.7 13 215.3.3 8.9-1.8 16.8 4.8 14 11.7z"
              ></path>
            </svg>
          </span>
        )}
      </div>
      <div className={chatside ? "" : "d-none"}>
        <div className="chatlist">
          <h6 className="chat_head mb-0">Support</h6>

          {ChatAvailabiltity?.status ? (
            <>
              {!isEmpty(payload?.EmailId) || !isEmpty(data?.EmailId) ? (
                <>
                  <div className="chattext_box" ref={chatContainerRef}>
                    <div className="text-center">
                      <img
                        src={edafacelogo}
                        className="img-fluid img_head mt-2 mb-2"
                      />
                    </div>
                    <div className={"box_left mb-3 mt-1"}>
                      <p className="mb-0 textbreak fw-600">
                        {ChatSettingData?.initialtext
                          ? ChatSettingData?.initialtext
                          : "Hi...! how can i assist you."}
                      </p>
                    </div>
                    <>
                      {chattextboxes.length > 0 &&
                        chattextboxes.map((msg) => (
                          <>
                            {msg?.files?.length > 0 &&
                              msg.files?.map((file, i) => {
                                if (file?.includes(".webp")) {
                                  return (
                                    <div
                                      className={
                                        msg.messager == "admin"
                                          ? "box_left mb-3"
                                          : "box_right mb-3"
                                      }
                                      style={{
                                        width: "fit-content",
                                        minWidth: "fit-content",
                                      }}
                                    >
                                      <a
                                        href={`${config.Img_URL}/${file}`}
                                        target="_blank"
                                      >
                                        <img
                                          src={`${config.Img_URL}/${file}`}
                                          className="img-fluid chatimage mb-2"
                                        />
                                      </a>
                                      <p className="mb-0 timepos">
                                        <MdAccessTime />{" "}
                                        {`${
                                          new Date(msg?.createdAt).getHours() >
                                          12
                                            ? `${
                                                new Date(
                                                  msg?.createdAt
                                                ).getHours() - 12
                                              }`
                                            : new Date(
                                                msg?.createdAt
                                              ).getHours()
                                        }.${new Date(
                                          msg?.createdAt
                                        ).getMinutes()}`}{" "}
                                        {new Date(msg?.createdAt).getHours() >=
                                        12
                                          ? "PM"
                                          : "AM"}
                                      </p>
                                    </div>
                                  );
                                } else if (file?.includes(".webm")) {
                                  return (
                                    <div
                                      className={
                                        msg.messager == "admin"
                                          ? "box_left mb-3"
                                          : "box_right mb-3"
                                      }
                                      style={{
                                        width: "fit-content",
                                        minWidth: "fit-content",
                                      }}
                                    >
                                      <a
                                        className="text-white"
                                        href={`${config.Img_URL}/${file}`}
                                        target="_blank"
                                      >
                                        <video
                                          src={`${config.Img_URL}/${file}`}
                                          className="img-fluid chatimage mb-2"
                                        />
                                        <p className="mb-0 timepos">
                                          <MdAccessTime />{" "}
                                          {`${
                                            new Date(
                                              msg?.createdAt
                                            ).getHours() > 12
                                              ? `${
                                                  new Date(
                                                    msg?.createdAt
                                                  ).getHours() - 12
                                                }`
                                              : new Date(
                                                  msg?.createdAt
                                                ).getHours()
                                          }.${new Date(
                                            msg?.createdAt
                                          ).getMinutes()}`}{" "}
                                          {new Date(
                                            msg?.createdAt
                                          ).getHours() >= 12
                                            ? "PM"
                                            : "AM"}
                                        </p>
                                        <MdOutlinePlayCircle className="playpos" />
                                      </a>
                                    </div>
                                  );
                                } else {
                                  return (
                                    <div
                                      className={
                                        msg.messager == "admin"
                                          ? "box_left mb-3"
                                          : "box_right mb-3"
                                      }
                                      style={{
                                        width: "120px",
                                        minWidth: "120px",
                                      }}
                                    >
                                      <a
                                        href={`${config.Img_URL}/${file}`}
                                        className="text-white"
                                        target="_blank"
                                      >
                                        <span className="uploadlogos ">
                                          <IoMdDocument
                                            className="h-25 text-dark"
                                            style={{ width: "50px" }}
                                          />
                                          <p className="mb-2 fw-600 text-dark">
                                            {msg?.filenames?.[i]}
                                          </p>
                                        </span>
                                      </a>
                                      <p className="mb-0 timepos">
                                        <MdAccessTime />{" "}
                                        {`${
                                          new Date(msg?.createdAt).getHours() >
                                          12
                                            ? `${
                                                new Date(
                                                  msg?.createdAt
                                                ).getHours() - 12
                                              }`
                                            : new Date(
                                                msg?.createdAt
                                              ).getHours()
                                        }.${new Date(
                                          msg?.createdAt
                                        ).getMinutes()}`}{" "}
                                        {new Date(msg?.createdAt).getHours() >=
                                        12
                                          ? "PM"
                                          : "AM"}
                                      </p>
                                    </div>
                                  );
                                }
                              })}
                            {!isEmpty(msg.msg) && (
                              <div
                                className={
                                  msg.messager == "admin"
                                    ? "box_left mb-3"
                                    : "box_right mb-3"
                                }
                              >
                                <p className="mb-2 textbreak fw-600">
                                  {msg.msg}
                                </p>
                                <p className="mb-0 timepos">
                                  <MdAccessTime />{" "}
                                  {`${
                                    new Date(msg?.createdAt).getHours() > 12
                                      ? `${
                                          new Date(msg?.createdAt).getHours() -
                                          12
                                        }`
                                      : new Date(msg?.createdAt).getHours()
                                  }.${new Date(
                                    msg?.createdAt
                                  ).getMinutes()}`}{" "}
                                  {new Date(msg?.createdAt).getHours() >= 12
                                    ? "PM"
                                    : "AM"}
                                </p>
                              </div>
                            )}
                          </>
                        ))}
                    </>
                  </div>
                  <>
                    {files?.length > 0 && (
                      <div className="px-2 wrapss">
                        {files?.map((img, i) => {
                          return (
                            <div className="pos widthset">
                              {img.type.includes("image") ? (
                                <img
                                  src={URL.createObjectURL(img)}
                                  className="img-fluid uploadlogos"
                                />
                              ) : img.type.includes("video") ? (
                                <video
                                  src={URL.createObjectURL(img)}
                                  className="img-fluid uploadlogos"
                                />
                              ) : (
                                <span className="uploadlogos d-flex align-items-center justify-content-center flex-column">
                                  <IoMdDocument className="w-25 h-25" />
                                  <p className="mb-0">{img.name}</p>
                                </span>
                              )}
                              <IoCloseCircleOutline
                                className="closeicon"
                                onClick={() => removeImg(i)}
                              />{" "}
                            </div>
                          );
                        })}
                      </div>
                    )}
                    <div className="px-2">
                      <div class="input-group gap-1 mb-2">
                        <input
                          type="text"
                          class="form-control"
                          onChange={(e) => setMsg(e.target.value)}
                          value={msg}
                          placeholder="Message"
                          aria-label="Recipient's username"
                          aria-describedby="basic-addon2"
                          onKeyDown={(e) =>
                            e.key == "Enter" ? messageSend() : null
                          }
                          disabled={DisableStatus}
                        />
                        <div class="input-group-append">
                          <input
                            type="file"
                            className="d-none"
                            multiple
                            ref={fileref}
                            onChange={getfiles}
                          />
                          <button
                            class="btn btn-brand-1 hover-up sendbtn"
                            type="button"
                            onClick={() => handleClick()}
                          >
                            <IoMdAttach />
                          </button>
                        </div>
                        <div class="input-group-append">
                          <button
                            class="btn btn-brand-1 hover-up sendbtn"
                            type="button"
                            onClick={() => messageSend()}
                            disabled={DisableStatus}
                          >
                            <IoSend />
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                </>
              ) : (
                <>
                  {!verifysteps && (
                    <>
                      {" "}
                      <div className="text-center">
                        <img
                          src={edafacelogo}
                          className="img-fluid img_head mt-2"
                        />
                      </div>
                      <div className="full_list">
                        <button
                          class="btn btn-brand-1 hover-up mb-3"
                          onClick={() => {
                            chatfirst();
                            navigate("/login");
                          }}
                          type="button"
                        >
                          Go to Login
                        </button>
                        <br></br>
                        <button
                          class="btn btn-brand-1 hover-up"
                          type="button"
                          onClick={() => setVerifysteps(true)}
                        >
                          Continue as visiter
                        </button>
                      </div>
                    </>
                  )}
                  {verifysteps && !otpPage && (
                    <>
                      {" "}
                      <div className="text-center">
                        <img
                          src={edafacelogo}
                          className="img-fluid img_head mt-2"
                        />
                      </div>{" "}
                      <div className="full_list mx-3">
                        <h6 className="text-start mb-2">Email Id</h6>
                        <input
                          className="form-control"
                          type="email"
                          onChange={(e) => setEmailId(e.target.value)}
                          placeholder="Email"
                          value={EmailId}
                        />
                        <button
                          class="btn btn-brand-1 hover-up mt-3"
                          type="button"
                          onClick={() => {
                            if (
                              !isEmpty(EmailId) &&
                              /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(EmailId)
                            ) {
                              sendOtp();
                            } else {
                              if (isEmpty(EmailId)) {
                                toast.error("Please fill the  Email ");
                              } else {
                                toast.error(
                                  "Please fill the Correct Email format"
                                );
                              }
                            }
                          }}
                        >
                          Continue as Chat
                        </button>
                      </div>
                    </>
                  )}

                  {verifysteps && otpPage && (
                    <>
                      {" "}
                      <div className="text-center">
                        <img
                          src={edafacelogo}
                          className="img-fluid img_head mt-2"
                        />
                      </div>
                      <div className="full_list mx-3">
                        <h6 className="text-center mb-3">OTP</h6>
                        <div className="otplist">
                          <OTPInput
                            value={userotp}
                            onChange={(e) => setUserotp(NumberOnly(e))}
                            numInputs={4}
                            renderSeparator={<span>-</span>}
                            renderInput={(props) => <input {...props} />}
                          />
                        </div>
                        <div class="col-lg-12">
                          <div class="form-group mb-4">
                            <p className="pr-4">
                              {" "}
                              Otp will{" "}
                              {Timer.Seconds == 0 && Timer.Minutes == 0
                                ? "expired"
                                : "expires in"}{" "}
                              <b>
                                {" "}
                                {Timer.Minutes}:{Timer.Seconds}
                              </b>
                            </p>
                          </div>
                        </div>
                        {/* <input className="form-control" type="email" onChange={(e) => setUserotp(e.target.value)} placeholder="Email" value={EmailId} /> */}
                        <button
                          class="btn btn-brand-1 hover-up mt-3 text-capitalize"
                          type="button"
                          onClick={() =>
                            isEmpty(page) ? goToChat() : sendOtp()
                          }
                        >
                          {isEmpty(page) ? "Continue as Chat" : page}
                        </button>
                      </div>
                    </>
                  )}
                </>
              )}
            </>
          ) : (
            <div className="py-3 px-3 hset">
              <div className="text-center">
                <img
                  src={edafacelogo}
                  className="img-fluid img_head mt-2 mb-2"
                />
              </div>
              <div
                dangerouslySetInnerHTML={{ __html: ChatAvailabiltity.text }}
                className="mt-2"
              ></div>
            </div>
          )}
        </div>
      </div>

      {/* chart code end */}
    </>
  );
}
